// Main Menu, Desktop & JS
ready(() => {

    // tap once on main menu --> open submenu
    const body = find('body');
    const menu = find('.main-menu');
    const menuItems = menu.findAll('.menu-item');
    const menuItemLinks = menu.findAll('.menu-item a');
    const menuDropdowns = findAll('.menu-dropdown');

    function hideAllMenuDropdowns() {
        menuDropdowns.forEach((menuDropdown) => {
            menuDropdown.classList.remove("open");
        });
        menuItems.forEach((menuItem) => {
            menuItem.classList.remove('open');
        });
    }

    function hideAllPageLinks() {
        const pageLinks = findAll('.page-links-wrap .page-links');
        pageLinks.forEach((pageLink) => {
            pageLink.classList.remove("open");
        });
        const menu2ndLevelItems = findAll('.menu-2nd-level .menu-item');
        menu2ndLevelItems.forEach((menu2ndLevelItem) => {
            menu2ndLevelItem.classList.remove('open');
        });
    }

    menuItemLinks.forEach((link) => {
        link.on("click", function(e) {
            const parentLi = this.parentNode;
            if (parentLi.classList.contains('has-children')) {

                // already opened? toggle menu
                if (parentLi.classList.contains('open')) {
                    hideAllMenuDropdowns();
                    return;
                }

                // already opened? go to page
                //if (parentLi.classList.contains('open')) {
                //    return;
                //}

                e.preventDefault();

                const id = parentLi.getAttribute('data-id');
                const menuDropdown = find('.menu-dropdown[data-id="' + id + '"]');

                hideAllMenuDropdowns();
                parentLi.classList.add('open');
                menuDropdown.classList.add("open");
            }
        });
    });

    // click anywhere outside the menu to close it
    document.on("click", function(e) {
        const target = e.target;
        const isMenuItem = target.closest('.menu-item');
        const isMenuDropdown = target.closest('.menu-dropdown');

        if (!isMenuItem && !isMenuDropdown) {
            hideAllMenuDropdowns();
        }
    });

    menuDropdowns.forEach((menuDropdown) => {

        const menu2ndLevelItems = menuDropdown.findAll('.menu-2nd-level .menu-item');
        const menu2ndLevelItemLinks = menuDropdown.findAll('.menu-2nd-level .menu-item a');
        const pageLinks = menuDropdown.findAll('.page-links-wrap .page-links');

        // handle 2nd level menu item actions (for both click and hover)
        function handleMenu2ndLevelItemAction(e, el) {

            const parentLi = el.parentNode;

            if (!parentLi.classList.contains('has-children')) {
                return;
            }

            // already opened? go to page
            if (parentLi.classList.contains('open')) {
                return;
            }

            e.preventDefault();

            const id = parentLi.getAttribute('data-id');
            const pageLinks = find('.page-links[data-id="' + id + '"]');

            hideAllPageLinks();
            parentLi.classList.add('open');
            pageLinks.classList.add("open");
        }



        // click on menu2ndLevelItemLink -> add class open to pageLinks item with the same data-id
        menu2ndLevelItemLinks.forEach((link) => {
            link.on("click", function(e) {
                handleMenu2ndLevelItemAction(e, this);
            });

        });

        // if no 2nd level .menu-item has class is-active or has-active-children, select the first one
        const activeMenuItems = menuDropdown.findAll('.menu-2nd-level .menu-item.is-active, .menu-2nd-level .menu-item.has-active-children');
        if(!activeMenuItems.length) {
            const firstItem = menu2ndLevelItems[0];
            if (firstItem) {
                const id = firstItem.getAttribute('data-id');
                const pageLinks = find('.page-links[data-id="' + id + '"]');
                firstItem.classList.add('open');
                pageLinks.classList.add("open");
            }
        }


    });


    // Mobile Menu
    const mobileMenuToggle = find('.mobile-menu-toggle');
    const mobileMenuItem1 = findAll('.mobile-menu > ul > li.has-children > a');

    // toggle mobile menu
    mobileMenuToggle.on('click', function(e) {
        e.preventDefault();
        body.classList.toggle('mobile-menu-open');
    });

    mobileMenuItem1.forEach((menuItem) => {

        menuItem.on('click', function(ev) {
            const parentLi = ev.currentTarget.parentNode;

            // already open? go to page
            if (!parentLi.classList.contains('open')) {
                ev.preventDefault();
                parentLi.classList.add('open');
            }

        });

    });

    // resize page: close menus
    window.addEventListener('resize', function(ev) {
        body.classList.remove('mobile-menu-open');

        menuItems.forEach(function(menuItem) {
            menuItem.classList.remove('open');
        });

        menuDropdowns.forEach(function(menuDropdown) {
            menuDropdown.classList.remove('open');
        });
    });



});
